export const paginationConfig = {
  size: [20, 30, 50],
  defaultSize: 20,
  showFirstLastButton: true,
} as const;
export default paginationConfig;
